import React, { memo, ReactNode } from 'react';

import styled from 'styled-components';
import { careerType } from 'services/careerType';
import { mobile } from 'services/ui';
import { Colors } from 'context';

interface IGrowthSectionLayout {
  title: string;
  lead: string;
  children: ReactNode;
}

/**
 * Общая рамка подстраниц раздела: заголовок и лид.
 *
 * ТЗ 0069: ролевой гард, плашка предпросмотра и ожидание карты членства
 * переехали в `CareerLayout` — теперь они общие для всех восьми экранов
 * `/career/*`.
 *
 * Хлебная крошка снята: она вела «← Мой рост» на дорожную карту (хаба больше
 * нет) и дублировала под-навигацию, которая стоит строкой выше.
 */
export const GrowthSectionLayout = memo(({ title, lead, children }: IGrowthSectionLayout) => (
  <PageWrapper>
    <header>
      <Title>{title}</Title>
      <Lead>{lead}</Lead>
    </header>
    {children}
  </PageWrapper>
));

const PageWrapper = styled.div`
  width: 100%;
  padding: 40px 0 80px;
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${mobile} {
    padding: 20px 0 48px;
  }
`;

// ТЗ 0071, п. 2.1: заголовок страницы 36 / 28, подводка — основной текст 16.
const Title = styled.h1`
  margin: 0;
  ${careerType.h1()};
`;

const Lead = styled.p`
  margin: 8px 0 0;
  max-width: 720px;
  color: ${Colors.gray_dark};
  ${careerType.body()};
`;
